import { Injectable } from '@angular/core';

import { UserService } from '@bytel/checkout';
import { AngularPrismeLogger } from '@bytel/prisme-logger/lib/angular';

import { BasicObject } from '@interfaces/checkout.interface';

import { DeviceDetectorService, DeviceInfo } from 'ngx-device-detector';

import { MainCartService } from './main-cart.service';

@Injectable({
    providedIn: 'root',
})
export class PrismeLoggerService {
    private _deviceInfo: DeviceInfo;
    constructor(
        private angularPrismeLogger: AngularPrismeLogger,
        private cartService: MainCartService,
        private userService: UserService,
        private deviceDetectorService: DeviceDetectorService,
    ) {
        this._deviceInfo = this.deviceDetectorService.getDeviceInfo();
    }

    /**
     * Method use to Send Prisme log
     * @param message Log message
     * @param ihm Current ihm or route
     * @param error Error if exist
     * @param cartId Current cartId if exist
     */
    public sendLogToPrisme(message: string, error: Error = null, additionalsData: BasicObject = {}): void {
        this.angularPrismeLogger.logToPrisme(message, {
            userId: this.userService.user.id,
            context: this.cartService.cartModel.getQuote().context.id,
            idPanier: this.cartService.cartModel.cartId ?? null,
            erreur: error,
            ...additionalsData,
            ...this._deviceInfo,
        });
    }
}
